import React from "react";

const FAQAnswers = ({ answer }) => {
  const formatAnswer = (text) => {
    if (!text) return null;

    const lines = text.split("\n").filter((line) => line.trim());

    return lines.map((line, index) => {
      if (line.trim().startsWith("-")) {
        return (
          <li key={index} className="ml-6 list-disc text-gray-700">
            {line.trim().slice(1).trim()}
          </li>
        );
      } else if (line.includes("**")) {
        return (
          <p key={index} className="text-gray-700">
            {line
              .split("**")
              .map((part, i) =>
                i % 2 === 1 ? <strong key={i}>{part}</strong> : part
              )}
          </p>
        );
      } else {
        return (
          <p key={index} className="mb-4 text-gray-700">
            {line.trim()}
          </p>
        );
      }
    });
  };

  if (answer.includes("|")) {
    const rows = answer.split("\n").filter((row) => row.trim());
    return (
      <table className="w-full text-gray-700 border-collapse">
        <tbody>
          {rows.map((row, index) => (
            <tr key={index} className="border-b">
              {row.split("|").map((cell, cellIndex) => (
                <td key={cellIndex} className="p-2">
                  {cell.trim()}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    );
  }

  return <div className="p-6 pt-0 bg-white">{formatAnswer(answer)}</div>;
};

export default FAQAnswers;
